const isLocalhost = window.location.hostname === 'localhost';
const redirectUrl = isLocalhost ? 'http://localhost:3001' : 'https://demo.arbitium.com';

const awsConfig: any = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_hEvXmhFKH',
      userPoolClientId: 'j1ufh727ua1k1er1pb8lthji2',
      loginWith: {
        oauth: {
          domain: 'arbitium-auth.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [redirectUrl],
          redirectSignOut: [redirectUrl],
          responseType: 'code'
        }
      }
    }
  }
};

export default awsConfig;
